<template>
  <div id="totalBox">
    <div class="partnerBox">
      <p class="partnerTitle">商务合作</p>
      <div class="partnerLogoBox">
        <div class="logoBox">
          <img src="../../assets/about/alipay.png" style="width: 196px;height: 66px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/wxpay.png" style="width: 220px;height: 62px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/gd.png" style="width: 227px;height: 66px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/xhsz.png" style="width: 200px;height: 48px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/dh.png" style="width: 192px;height: 98px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/sxhd.png" style="width: 200px;height: 77px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/rj.png" style="width: 145px;height: 137px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/dzdst.png" style="width: 121px;height: 118px;"/>
        </div>
        <div class="logoBox">
          <img src="../../assets/about/wym.png" style="width: 245px;height: 44px;"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Busnesspartner',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 650px;
  background:rgba(250,250,250,1);
}
.partnerBox{
  width: 1200px;
  height: 650px;
  margin: 0 auto;
  padding-top: 22px;
  text-align: left;
  padding-top: 40px;
}
.partnerTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  text-align: center;
  margin-bottom: 33px;
}
.partnerLogoBox{
  width: 100%;
  height: 508px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.logoBox{
  width: 400px;
  height: 168px;
  border-bottom: 1px solid RGBA(231, 231, 231, 1);
  border-right: 1px solid RGBA(231, 231, 231, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.logoBox:nth-of-type(3n){
  border-right: none;
}
.logoBox:nth-of-type(7),.logoBox:nth-of-type(8),.logoBox:nth-of-type(9){
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/about/busnessPartner.vue